import React from "react";
import { VERSION_INFO } from "@eaigle/utils/version-info";

interface VersionPageProps {
  className?: string;
  appName?: string;
}

export const VersionPage: React.FC<VersionPageProps> = ({
  className = "",
  appName = "Application",
}) => {
  const formatDate = (dateString: string): string => {
    if (dateString === "unknown") return "Unknown";

    try {
      const date = new Date(dateString);
      return date.toISOString();
    } catch {
      return dateString;
    }
  };

  const copyToClipboard = (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        // Could add a toast notification here
        console.log("Copied to clipboard:", text);
      })
      .catch((err) => {
        console.error("Failed to copy to clipboard:", err);
      });
  };

  return (
    <div className={`version-page w-full h-full bg-white ${className}`}>
      <div className="max-w-2xl mx-auto p-6">
        <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center" id="Title">
          {appName} Version Information
        </h1>

        <div className="bg-white rounded-lg shadow-lg p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
            {/* Build Date */}
            <div className="bg-gray-50 rounded-lg p-4">
              <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wide mb-2">
                Build Date
              </h3>
              <div className="flex items-center justify-between">
                <span className="text-lg text-gray-900" id="BuildDate">
                  {formatDate(VERSION_INFO.buildDate)}
                </span>
                <button
                  onClick={() => copyToClipboard(VERSION_INFO.buildDate)}
                  className="text-blue-600 hover:text-blue-800 text-sm underline"
                  title="Copy to clipboard"
                >
                  Copy
                </button>
              </div>
            </div>

            {/* Git Commit Hash */}
            <div className="bg-gray-50 rounded-lg p-4">
              <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wide mb-2">
                Git Commit Hash
              </h3>
              <div className="flex items-center justify-between">
                <span
                  className="text-lg font-mono text-gray-900 break-all"
                  id="CommitHash"
                >
                  {VERSION_INFO.gitCommitHash}
                </span>
                <button
                  onClick={() => copyToClipboard(VERSION_INFO.gitCommitHash)}
                  className="text-blue-600 hover:text-blue-800 text-sm underline ml-2"
                  title="Copy to clipboard"
                >
                  Copy
                </button>
              </div>
            </div>

            {/* Git Commit Date */}
            <div className="bg-gray-50 rounded-lg p-4">
              <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wide mb-2">
                Commit Date
              </h3>
              <div className="flex items-center justify-between">
                <span className="text-lg text-gray-900" id="CommitDate">
                  {formatDate(VERSION_INFO.gitCommitDate)}
                </span>
                <button
                  onClick={() => copyToClipboard(VERSION_INFO.gitCommitDate)}
                  className="text-blue-600 hover:text-blue-800 text-sm underline"
                  title="Copy to clipboard"
                >
                  Copy
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VersionPage;
